module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/modules/_is-object.js
// module id = 672
// module chunks = 0